module.exports = __webpack_public_path__ + "img/arrow_down_icon.3c749cd8.svg";